import React from 'react'
import { Box, Grid, Paper, Stack, Typography } from '@mui/material'
import {
  PeopleAlt,
  LocalHospital,
  HourglassTop,
  VolunteerActivism,
  Hotel,
  AirlineSeatIndividualSuite,
} from '@mui/icons-material'

const statConfig = {
  totalPatients: {
    label: 'Total Patients',
    icon: PeopleAlt,
    color: '#8B5CF6',
  },
  inTreatment: {
    label: 'In Treatment',
    icon: LocalHospital,
    color: '#F59E0B',
  },
  waiting: {
    label: 'Waiting',
    icon: HourglassTop,
    color: '#EAB308',
  },
  welfare: {
    label: 'Welfare',
    icon: VolunteerActivism,
    color: '#22C55E',
  },
  availableBeds: {
    label: 'Available Beds',
    icon: Hotel,
    color: '#3B82F6',
  },
  occupiedBeds: {
    label: 'Occupied Beds',
    icon: AirlineSeatIndividualSuite,
    color: '#EF4444',
  },
}

const TreatmentStatCard = ({ label, value, icon: Icon, color }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 4,
        flex: 1,
        // minHeight: 118,
        display: 'flex',
        alignItems: 'center',
        background:
          'linear-gradient(135deg, rgba(15,23,42,0.98), rgba(30,41,59,0.92))',
        border: '1px solid rgba(148,163,184,0.18)',
        boxShadow: '0 10px 28px rgba(15,23,42,0.18)',
        color: 'white',
      }}
    >
      <Stack spacing={1.25} width="100%">
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
        >
          <Box
            sx={{
              width: 38,
              height: 38,
              borderRadius: 2.5,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              backgroundColor: `${color}22`,
              color,
            }}
          >
            <Icon fontSize="small" />
          </Box>

          <Typography
            sx={{
              fontSize: '2rem',
              fontWeight: 900,
              lineHeight: 1,
              color: 'white',
            }}
          >
            {value}
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: 'rgba(255,255,255,0.72)',
            fontWeight: 800,
            fontSize: '0.9rem',
            lineHeight: 1.2,
          }}
        >
          {label}
        </Typography>

        <Box
          sx={{
            height: 3,
            width: 42,
            borderRadius: 999,
            backgroundColor: color,
            opacity: 0.85,
          }}
        />
      </Stack>
    </Paper>
  )
}

const TreatmentStatsCards = ({ stats = {} }) => {
  const cards = [
    {
      key: 'totalPatients',
      value: stats.totalPatients ?? 0,
    },
    {
      key: 'inTreatment',
      value: stats.inTreatment ?? 0,
    },
    {
      key: 'waiting',
      value: stats.waiting ?? 0,
    },
    {
      key: 'welfare',
      value: stats.welfare ?? 0,
    },
    {
      key: 'availableBeds',
      value: stats.availableBeds ?? 0,
    },
    {
      key: 'occupiedBeds',
      value: stats.occupiedBeds ?? 0,
    },
  ]

  return (
    <Box>
      <Grid container spacing={2} display="flex">
        {cards.map(({ key, value }) => {
          const config = statConfig[key]

          return (
            <Grid
              item
              xs={6}
              md={4}
              lg={2}
              key={key}
              sx={{ display: 'flex' }}
            >
              <TreatmentStatCard
                label={config.label}
                value={value}
                icon={config.icon}
                color={config.color}
              />
            </Grid>
          )
        })}
      </Grid>
    </Box>
  )
}

export default TreatmentStatsCards
